/* tslint:disable: no-switch-case-fall-through */
import { ActionWithPayload } from '../../app.interfaces';

import { helpers } from '../../helpers';
import { UserActions } from './user.actions';
import { UserState } from './user.interfaces';

export const userInitialState: UserState = {
  user: {},
  lang: 'it',
  loading: false,
  loaded: false,
  locked: false,
  error: null
};

export function userReducer(state = userInitialState, {type, payload}: ActionWithPayload): UserState {
  let nextState: UserState;

  switch (type) {

    case UserActions.LOGIN_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        user: payload.user,
        loaded: true,
        error: null
      });
      return nextState;
    }

    case UserActions.LOGIN_FAIL: {
      let errorPayload = payload;
      if (typeof errorPayload !== 'object') {
        errorPayload = {
          message: payload,
          preventAutoclose: false
        }
      }
      nextState = helpers.immutAssign({}, state, {
        loading: false,
        error: errorPayload
      });
      nextState.error.preventAutoclose = true;
      return nextState;
    }

    case UserActions.LOGOUT: {
      nextState = helpers.immutAssign({}, state, {
        loaded: false,
        '<user': null
      });
      return nextState;
    }

    case UserActions.AUTO_LOGIN:
    case UserActions.LOGIN: {
      nextState = helpers.immutAssign({}, state, {
        loading: true
      });
      return nextState;
    }

    case UserActions.LOCK_USER: {
      nextState = helpers.immutAssign({}, state, {
        locked: true
      });
      return nextState;
    }

    case UserActions.SET_LANGUAGE: {
      nextState = helpers.immutAssign({}, state, {
        lang: payload
      });
      return nextState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/logics/user/user.reducer.ts